













import Vue from 'vue'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'

import TableAlarm from './table-alarm.vue'
import AlarmProperties from './alarm-properties.vue'
import { AlarmSetting } from '@/api/alarm'

export default Vue.extend({
  name: 'ComponentName',
  components: {
    TableAlarm,
    AlarmProperties,
    Splitpanes,
    Pane,
  },
  data() {
    return {
      selected: { advanced: {} } as AlarmSetting,
    }
  },
  methods: {
    selectedChanged(val: AlarmSetting) {
      this.selected = val
    },
  },
})
